import { autorun } from 'mobx'
import env from '@env'
import axios from 'axios'
import FeeClient from 'sdk/fee'
import { mpc } from '@dt/mmg-sdk'
import { restaurantCenter, restaurantConfig, deskMobx, menuMobx, storeMobx, RESTAURANT_EVENT, cartMobx, orderListMobx, productCenter, feeMobx, orderMobx, discountMobx, queueMobx, boxFeeMobx } from 'restaurant'
import { appMobx, memberMobx, timePickMobx, decorationMobx, multiPersonOrderingMobx, multiPersonMobx, queueOrderingMobx, orderLiveMobx, cartLiveMobx, localCache as cartCache, eatTypeStatusMobx, preOrderingMobx, deliveryMobx } from '@mobxStore'
import { modalLayer, alertLayer, getHistoryNew, getSourceType } from '@utils'
import { ddayjs, trace, addParams } from '@dt/fe-utils'
import { Develop as DevelopModal } from '@cps'
import { MenuStatusConfirmModal, StoreStatusConfirmModal } from '@pages/menu/modal'
import { WaiterModal } from '@pages/checkout/modal'
import { find, some } from '@dt/fe-utils/dist/lodash'
import { TEEatType } from 'restaurant/mobx/store.mobx'

// init fee 初始化税费sdk
const initFee = (brandId, storeId) => {
  if (bo === 'cn') {
    return
  }
  feeMobx.init().then((feeConfig: any) => {
    // feeConfig.tax = null
    FeeClient.init(feeConfig)
    restaurantCenter.setConfig({
      fee: FeeClient
    })
    // try {
    //   FeeClient.calculate({
    //     cityId: storeMobx.info.cityId,
    //     detail: [],
    //     diningOption: 'dinein',
    //     person: 1
    //   })
    //   // console.info('🍄 验证费用计算器验证成功')
    //   restaurantCenter.setConfig({
    //     fee: FeeClient
    //   })
    //   // console.info('🍄 验证费用计算器验证成功')
    // } catch (err) {
    //   console.error('🍄 验证费用计算器验证失败 无法加载')
    //   console.error(err)
    // }
  }, (err: any) => {
    console.error('🍄init fee error', err)
  })
}

// init mpc 初始化营销计sdk
const initMpc = () => {
  const channel = Config.buyTogetherId ? 'buyTogether' : (Config.codeType === 'brand' ? cartMobx.channel : 'mobile')
  const currStore = find(storeMobx.storeList, (info: IViewStore) => `${info.storeId}` === `${restaurantConfig.storeId}`)
  const canUseMmg: boolean = (currStore && currStore.saleResourceInfo && currStore.saleResourceInfo.member_mobile && currStore.saleResourceInfo.member_mobile.isExpire === false)
  let eatType = Config.buyTogetherId || cartMobx.info.eatType || (Config.codeType === 'brand' ? 'delivery' : 'togo')
  if (location.pathname.indexOf('/mall') > -1 || location.pathname.indexOf('/mproduct') > -1) {
    eatType = 'mall'
  }
  mpc.init({
    brandId: restaurantConfig.brandId, // 品牌ID
    storeId: restaurantConfig.storeId, // 门店ID
    domain: ENV.SERVERDOMAIN, // 域名
    eatType: eatType, // 吃的类型0
    appType: 'Mobile', // app类型
    channel, // 渠道类型
    token: '',
    timeZone: storeMobx.brand.timeZone,
    bo,
    canUseMmg,
    ...window.grayMaker()
  }).then(() => {
    // console.log('mmg mpc init success')
  })
  // mkt 获取用户信息
  if (Config.token) memberMobx.initMpc()
}

export default (history: any) => {
  let oneStoreId = 0
  const currStore = find(storeMobx.storeList, (info: IViewStore) => `${info.storeId}` === `${restaurantConfig.storeId}`)
  const canUseMemberMobile: boolean = (currStore && currStore.saleResourceInfo && currStore.saleResourceInfo.member_mobile && currStore.saleResourceInfo.member_mobile?.isExpire === true)
  // !!! 置入restaurant 体系
  restaurantCenter.setConfig({
    mpc,
    deviceId: appMobx.deviceId,
    promotionId: Config.promotionId
  })

  // autorun
  autorun(() => {
    if (memberMobx.isLogin) {
      // console.log('🍙 营销会员信息置入 mpc')
      restaurantCenter.setConfig({
        member: {
          type: memberMobx.memberInfo.type,
          id: String(memberMobx.memberInfo.memberId),
          mobile: memberMobx.memberInfo.mobile,
          email: memberMobx.memberInfo.email,
          key: bo === 'cn' ? (String(memberMobx.memberInfo.memberId) || memberMobx.memberInfo.visitorId) : (memberMobx.memberInfo.visitorId || String(memberMobx.memberInfo.memberId)),
          nickName: memberMobx.memberInfo.nickName,
          avatar: memberMobx.memberInfo.avatarUrl,
          openId: memberMobx.memberInfo.openId
        }
      })
      // 前端监控追踪用户id
      trace.setConfig({ uid: `${Config.BRANDID}_${Config.STOREID}_${memberMobx.memberInfo?.memberId}` })
    } else {
      restaurantCenter.setConfig({
        member: {
          type: multiPersonMobx.currentPersonInfo?.personType as any,
          key: multiPersonMobx.currentPersonInfo?.personId,
          nickName: multiPersonMobx.currentPersonInfo?.nickName
        }
      })
      // restaurantCenter.setConfig('member', undefined)
    }
  })

  // 品牌切换事件
  restaurantCenter.on(RESTAURANT_EVENT.BRAND_CHANGED, (info: IBrand) => {
    // 处理bo
    if (info.bo !== bo) {
      window.bo = info.bo
      localStorage.setItem('brand.bo', info.bo)
    }
    if (info.bo) {
      restaurantCenter.setConfig({ bo: info.bo })
    }

    // 安全的置入请求头中的bo
    if (info.bo) {
      axios.defaults.headers.common.bo = info.bo
    }

    // 时区
    if (info.timeZone) {
      ddayjs.setBrandTimezone(info.timeZone as any)
    }

    // 初始化mpc
    initMpc()

    // 设置头部信息
    // document.title = info.brandName
  })
  // 标记第一次设置门店
  let isFirstInitStore = true
  // 门店切换事件
  restaurantCenter.on(RESTAURANT_EVENT.STORE_CHANGED, (info: IStore) => {
    // 打包费初始化
    boxFeeMobx.init()
    // sourceType
    restaurantCenter.setConfig({
      sourceType: getSourceType(Config, info.storeOrderType)
    })

    menuMobx.selectCategory()

    // 桌码建立多人点餐连接
    if (Config.codeType === 'table' && Config.TABLECODE && Config.STOREID) {
      if (storeMobx.info.openMultiPersonOrdering || storeMobx.storeSceneConfig.payMode) {
        if (window.MX) {
          window.MX.multiPersonMobx = multiPersonMobx
        }
        multiPersonOrderingMobx.connect(Config.STOREID, Number(Config.TABLECODE), (data: any) => {
          cartLiveMobx.init(data)
          multiPersonMobx.init(data?.user, data?.person)
        })
      } else {
        multiPersonOrderingMobx.delMultiRoom()
        multiPersonMobx.clearCurrentPersonInfo()
      }
    }

    // 当前进入门店处理事件
    if (info.storeId && info.storeId !== oneStoreId) {
      oneStoreId = info.storeId
      if (Config.codeType === 'table') {
        deskMobx.init()
        cartMobx.setTableCode(Config.TABLECODE)
        // 获取桌台上的订单列表
        orderListMobx.getTabelCodeOrder(cartMobx.info.tableCode).then((res: any) => {
          if (res.length && res[0].status === 'Pending' && res[0].payMode) {
            // 桌子有订单数据 && 该订单数据是后付费， 占桌， 手机点餐全部统一为后付费
            // cartMobx.setPayMode(1)
            // sessionStorage.setItem('beforeOrdersId', res[0].ordersId)
            // 如果是预支付, 直接去订单详情页面
            if (res[0].status === 'Paying') {
              history.push(`/result/${res[0].ordersId}`)
            } else {
              cartMobx.setOrdersId(res[0].ordersId)
              history.push('/checkout')
            }
          }
        }).catch(() => { }).finally(() => {
          cartMobx.setPayMode(storeMobx.storeSceneConfig.payMode)
        })
      }
      initFee(info.brandId, info.storeId)
      mpc.switchStore(oneStoreId)
      mpc.refresh()
      // 初始化首页推荐数据
      // recommendMobx.clear()
      // recommendMobx.initHomeRecommend()
      Config.STOREID = info.storeId

      // 安全的置入请求头中的timeZone
      if (info.timeZone) {
        Config.timezone = info.timeZone
        mpc.setTimeZone(storeMobx.info.timeZone)
        axios.defaults.headers.common.timezone = info.timeZone
        ddayjs.setStoreTimezone(info.timeZone as any)
      }

      // 切换就餐方式
      if (storeMobx.info.eatType?.length) {
        let _eatType = Config.eatType || decorationMobx.defaultEatType
        console.log('🍄 切换就餐方式', Config.eatType, decorationMobx.defaultEatType)
        if (Config.codeType === 'brand' && cartMobx.info.eatType) {
          if (eatTypeStatusMobx.checkBrandEatTypeInStore(cartMobx.info.eatType)) {
            _eatType = cartMobx.info.eatType
          }
        }

        /** 门店切换 当前门店开启就餐人数弹窗 就餐人数弹窗需要初始化 */
        if (Config.RESTAURANTAPP === 'mobile' && _eatType === TEEatType.dinein && info.diningNumberConfig?.status === 1 && cartMobx.info.person) {
          cartMobx.setPerson(0)
        }

        setTimeout(() => {
          isFirstInitStore = false
          cartMobx.setEatType(_eatType)
          discountMobx.switchEatType(_eatType)
        }, isFirstInitStore ? 100 : 0)
      }

      // 切换门店要清除上一家门店选中的时间
      productCenter.setAppointmentDate()
      productCenter.setAppointmentTime()

      // 门店切换，重新计算预约时间
      if (storeMobx.info.saleTime) {
        const hasAppointment = productCenter.appointmentTime !== ''
        const canReservation = !!storeMobx.info.isMobileBookingOrder
        if (storeMobx.info.status === 'resting' && (canReservation || !hasAppointment)) {
          timePickMobx.reset()
        } else {
          timePickMobx.reset(!(canReservation || !hasAppointment))
        }
      }

      // 排队信息
      if (['store', 'table'].includes(Config.codeType)) {
        queueOrderingMobx.getQueueInfo().then((res) => {
          if (Config.queueId && Config.codeType === 'store') {
            // 排队 init
            queueMobx.init()
            // 排队 socket connect
            queueOrderingMobx.connect(Config.STOREID, Config.queueId)
            // 排队 socket on emit
            queueOrderingMobx.onEmit()
          } else if (res?.status === 'Calling' && Config.codeType === 'table' && !!Config.TABLECODE) {
            if (Number(res?.tableCode) === Number(Config.TABLECODE)) {
              queueOrderingMobx.checkinCallByBuyer().catch((err: any) => {
                alertLayer({
                  message: err.message || i18n.t('queue.queueToTable', { table: res.tableAlias }),
                  cssClass: 'common-alert queue-to-table-alert',
                  backdropDismiss: false,
                })
              })
            } else {
              alertLayer({
                message: i18n.t('queue.queueToTable', { table: res.tableAlias }),
                cssClass: 'common-alert queue-to-table-alert',
                backdropDismiss: false,
              })
            }
          }
        })
      }
      // 桌台预点单
      if (['table'].includes(Config.codeType) && !!Config.TABLECODE) {
        queueOrderingMobx.getTableOrder()
      }
    }

    if (!cartMobx?.ordersId || orderMobx.viewOrder.status === 'Success') {
      cartMobx.setPayMode(storeMobx.storeSceneConfig.payMode)
    }

    /** 配送费重算 */
    if (cartMobx.info.eatType === TEEatType.delivery) {
      cartMobx.setExpressPrice(deliveryMobx.expressFee)
      cartMobx.setExpressList()
    }

    // for dev
    if (window.MX) {
      window.MX.multiPersonMobx = multiPersonMobx
    }
    initMpc()
    if (env.DISABLE_MKT) {
      restaurantConfig.mpc = null
    }
  })

  // 税费的配置变更
  restaurantCenter.on(RESTAURANT_EVENT.FEE_CONFIG_REFRESH, () => {
    if (storeMobx.info.storeId) {
      initFee(storeMobx.info.brandId, storeMobx.info.storeId)
    }
  })

  /** 等待接单的订单需要从本地购物车拿回购物车数据 */
  restaurantCenter.on(RESTAURANT_EVENT.ORDER_WAITING_ACCEPTED, ({ order }) => {
    const Cart = cartCache.getCart(order.storeId, order.ordersId)
    if (Cart && Cart?.ordersId === cartMobx.ordersId) {
      cartMobx.restoreByCopy(Cart, false)
    }
  })

  // 菜单刷新结束
  restaurantCenter.on(RESTAURANT_EVENT.MENU_END, () => {
    if (modalLayer.has('restoreOrderModal')) {
      return
    }
    if (!orderMobx.viewOrder?.ordersId || orderMobx.viewOrder.status === 'Success') {
      cartMobx.setPayMode(storeMobx.storeSceneConfig.payMode)
    }
    if (restaurantConfig.codeType === 'store' || restaurantConfig.codeType === 'table') {
      // 当前堂食不支持预约
      const canReservation = false
      const confirmText = canReservation ? i18n.t('menu.bookingOrder') : i18n.t('menu.seeMenu')
      if (storeMobx.info.status === 'resting') {
        setTimeout(() => {
          modalLayer(StoreStatusConfirmModal, {
            title: i18n.t('store.thisStoreResting'),
            confirmText,
            isLight: canReservation
          }, 'storeStatusConfirmModal')
        }, 100)
      } else if (!menuMobx.isAvailable) {
        modalLayer(MenuStatusConfirmModal, {
          title: i18n.t('store.productPrepare'),
          confirmText,
          isLight: canReservation
        }, 'menuStatusConfirmModal')
      }
    } else if (restaurantConfig.codeType === 'brand') {
      const hasAppointment = productCenter.appointmentTime !== ''
      const canReservation = !!(timePickMobx.canPick && storeMobx.info.isMobileBookingOrder)
      if (storeMobx.info.status === 'resting' && (canReservation || !hasAppointment) && location.pathname.indexOf('/result') < 0 && location.pathname.indexOf('/checkout') < 0) {
        setTimeout(() => {
          modalLayer(StoreStatusConfirmModal, {
            title: i18n.t('store.thisStoreResting'),
            confirmText: canReservation ? i18n.t('menu.bookingOrder') : i18n.t('store.goinSee'),
            isLight: canReservation
          }, 'storeStatusConfirmModal')
        }, 100)
      } else if (!menuMobx.isAvailable) {
        modalLayer(MenuStatusConfirmModal, {
          title: i18n.t('store.productPrepare'),
          confirmText: canReservation && !hasAppointment ? i18n.t('menu.bookingOrder') : i18n.t('store.goinSee'),
        }, 'menuStatusConfirmModal')
      }
    }
    // 不启用本地缓存(后付费会员购物车、当前购物车已下单、拼单、桌码多人点餐、排队预点餐)
    if (!cartMobx.ordersId && !(Config.codeType === 'brand' && Config.buyTogetherId) && !(Config.codeType === 'table' && Config.TABLECODE && storeMobx.info?.openMultiPersonOrdering) && !(Config.codeType === 'store' && Config.queueId)) {
      const Cart = preOrderingMobx.checkPreOrder ? preOrderingMobx.getCart(productCenter.storeId) : cartCache.getCart(productCenter.storeId)
      // payMode: 扫桌码通过桌码判断payMode值， 如果是品牌码或者店码都是先付费 cartMobx.reset()
      if (Cart) {
        // 如果存在购物车
        cartMobx.restoreByCopy(Cart, false)
      } else {
        // 不存在缓存数据，清除上一家门店遗留购物车数据
        cartMobx.clear()
      }
    }
  })

  // 处理订单状态变化
  restaurantCenter.on(RESTAURANT_EVENT.ORDER_STATUS_CHANGED, ({ fromSync, order }: { fromSync: boolean; order: { ordersId: string; status: string; mqAction: string } }) => {
    const history = getHistoryNew()
    if (order.status === 'Pending' && order.mqAction === 'orders.start') {
      cartMobx.setOrdersId(order.ordersId)
    } else if (order.status === 'Pending' && ['orders.updateDetailPrice', 'orders.reduce'].includes(order.mqAction)) { // 退菜，退款，改价
      cartMobx.setOrdersId(order.ordersId)
    } else if (order.status === 'Pending' && order.mqAction === 'orders.add') {
      cartMobx.setOrdersId(order.ordersId)
      //  当前回原时不再主动处理清空动作,所以需要手动触发
      // cartMobx.clear()'
      if (history.getState() === '/phoneCase') return
      if (storeMobx.storeSceneConfig.confirmOrders) {
        modalLayer(WaiterModal, {
          isWaitForReceive: false
        }, 'waiterModal').finally(() => {
          if (history.getState() !== '/checkout') {
            history.push('/checkout')
          }
        })
      } else if (history.getState() !== '/checkout') {
        history.push('/checkout')
      }
    } else if (order.mqAction === 'orders.paid') {
      // 在支付完成页不弹出
      if (history.getState() === `/result/${order.ordersId}` || history.getState() === '/phoneCase') {
        return
      }
      alertLayer({
        message: i18n.t('checkout.orderHasFinishedAndScanAgain'),
        button: i18n.t('cart.ikonw'),
        backdropDismiss: false
      }).then(() => {
        // 清空购物车
        cartMobx.clear()
        location.reload()
      })
    } else if (order.status === 'Cancel' && order.mqAction === 'orders.cancel' && !!cartMobx.info.payMode) {
      alertLayer({
        message: i18n.t('checkout.orderHasCancelAndScanAgain'),
        button: i18n.t('cart.ikonw'),
        backdropDismiss: false
      }).then(() => {
        // 清空购物车
        cartMobx.clear()
        location.reload()
      })
    }
  })

  // 处理订单桌台变化
  let hasTurnTableAlert = null
  restaurantCenter.on(RESTAURANT_EVENT.ORDER_TABLE_CHANGED, ({ fromSync, order }: { fromSync: boolean; order: { tableCodeClean: string; tableAliasClean: string; tableCodeOccupy?: string; tableAliasOccupy?: string } }) => {
    cartMobx.clearOrdersId()
    cartMobx.setOrdersPreId()
    orderMobx.reset()
    if (!hasTurnTableAlert && fromSync && order.tableCodeOccupy) {
      const _url = addParams({
        params: {
          t: order.tableCodeOccupy,
        }
      })
      hasTurnTableAlert = alertLayer({
        id: 'turnTableToAlert',
        message: i18n.t('checkout.turnTableTip', { table: order.tableAliasOccupy }),
        cssClass: 'common-alert',
        button: i18n.t('checkout.turnTableTo'),
        backdropDismiss: false,
      }).then(() => {
        location.replace(_url)
        hasTurnTableAlert = null
      })
      // setTimeout(() => {
      let _sec = 3
      let _timer = setInterval(() => {
        if (_sec === 0) {
          _timer = null
          clearInterval(_timer)
          location.replace(_url)
          return
        }
        let _warp = document.querySelector('#turnTableToAlert .alert-wrapper')
        let _bef = document.querySelector('#turnTableToAlert .alert-button-group')
        let _ele = document.querySelector('#turnTableToAlertCountDown')
        let _text = document.createTextNode(i18n.t('checkout.turnTableAuto', { num: _sec }))
        _ele && _warp?.removeChild(_ele)
        if (!_bef) return
        const _dom = document.createElement('div')
        _dom.id = 'turnTableToAlertCountDown'
        _dom.className = 'alert-message-sub'
        _dom.appendChild(_text)
        _warp?.insertBefore(_dom, _bef)
        _sec--
      }, 1000)
      // })
    }
  })

  // 处理订单取消
  let hasOrderFinishAlert = null
  restaurantCenter.on(RESTAURANT_EVENT.CANCEL_ORDER, ({ fromSync, order }: { fromSync: boolean; order: { ordersId: string } }) => {
    const history = getHistoryNew()
    if (fromSync) {
      cartMobx.clearOrdersId()
      cartMobx.setOrdersPreId()
      orderMobx.reset()
    }
    if (!hasOrderFinishAlert && fromSync && !Config.buyTogetherId) {
      if (history.getState().includes('/result') || history.getState() === '/phoneCase') {
        return
      }
      hasOrderFinishAlert = alertLayer({
        message: i18n.t('checkout.orderHasFinishedAndScanAgain'),
        button: i18n.t('cart.ikonw')
      }).then(() => {
        if (history.getState() === '/menu') {
          return
        }
        history.replace('/menu')
        hasOrderFinishAlert = null
      })
    }
    if (Config.buyTogetherId) {
      multiPersonOrderingMobx.delMultiRoom()
      multiPersonMobx.clearMultiPersonMap()
    }
  })

  // 当购物的餐品发生变化直接撤回订单的未下单餐品
  restaurantCenter.on(RESTAURANT_EVENT.CART_ITEMS_CHANGED, ({ fromSync, notCalcCart }) => {
    if (fromSync) {
      if (cartMobx.info.payMode && orderMobx.viewOrder.isWait) {
        orderLiveMobx.setNeedReorder(true)
      }
    } else {
      if (cartMobx.info.payMode && orderMobx.viewOrder.isWait && !notCalcCart) {
        // 置换pk防止pk重复 （会导致同步不一致的问题 估取消）
        // cartMobx.replacePk()
        alertLayer({
          message: i18n.t('checkout.modifyProductsNeedCheck'),
          button: i18n.t('cart.ikonw'),
          backdropDismiss: false
        })
        orderMobx.delTempCart().then(() => {
          orderLiveMobx.setNeedReorder(true)
        }, () => {
          // TODO 异常处理
          alertLayer({
            message: i18n.t('checkout.orderHasFinishedAndContactWaiter'),
            button: i18n.t('cart.ikonw'),
            backdropDismiss: false
          }).then(() => {
            const history = getHistoryNew()
            history.push('/result/' + orderMobx.order.ordersId)
          })
        })
      }
    }
  })

  // 当会员登录后，如果当前订单未下单，并且当前配置可以下单则直接下单
  restaurantCenter.on(RESTAURANT_EVENT.CONFIG_MEMBER_CHANGED, () => {
    const { memberConfirmOrders } = storeMobx.storeSceneConfig
    if (cartMobx.isWait && memberConfirmOrders === 1) {
      if (Config.codeType === 'table' && cartMobx.info.tableCode.toString() !== Config.TABLECODE.toString()) {
        cartMobx.setTableCode(Config.TABLECODE)
      }
      if (cartMobx.info.eatType !== 'delivery') {
        cartMobx.setContact({ contactName: memberMobx.memberInfo.nickName, contactMobile: memberMobx.memberInfo.mobile })
      }
      cartMobx.save().catch(() => {
        // TODO 异常处理
      })
    }
  })

  // 下单时触发通知
  let hasOrderAlert = null
  restaurantCenter.on(RESTAURANT_EVENT.SAVE_ORDER, ({ fromSync, order }) => {
    if (fromSync) {
      // 先付费就不需要弹了，因为会弹支付完成的弹窗
      if (!hasOrderAlert && !Config.buyTogetherId && cartMobx.info.payMode) {
        const addUserNmae = multiPersonMobx.multiPersonMap[order.addUser]?.nickName || ''
        hasOrderAlert = alertLayer({
          message: i18n.t('cart.orderHasPlaced', { name: addUserNmae }),
          button: i18n.t('order.checkOrder'),
        }).then(() => {
          cartMobx.setOrdersId(order.ordersId)
          const history = getHistoryNew()
          if (history.getState() !== '/checkout') {
            history.push('/checkout')
          }
          hasOrderAlert = null
        })
      } else {
        cartMobx.setOrdersId(order.ordersId)
      }
    }
  })

  // 就餐类型发生变化
  restaurantCenter.on(RESTAURANT_EVENT.EAT_TYPE_CHANGE, ({ eatType, fromHandler }) => {
    productCenter.initProduct(eatType)
    if (!cartMobx?.ordersId || orderMobx.viewOrder.status === 'Success') {
      cartMobx.setPayMode(storeMobx.storeSceneConfig.payMode)
    }
    if (eatType === 'delivery' && Config.codeType === 'brand' && storeMobx.info.storeId && !storeMobx.info.openSelfDelivery) {
      if (storeMobx.info.storeName) {
        cartMobx.setEatType(decorationMobx.defaultEatType)
      }
      return
    }
    if (Config.codeType === 'brand') {
      timePickMobx.reset()
    }
  })

  // 就餐渠道发生变化
  restaurantCenter.on(RESTAURANT_EVENT.ORDER_CHANNEL_CHANGED, ({ channel }) => {
    discountMobx.switchChannel(cartMobx.channel)
  })

  /** 订单自提后付费监听 */
  let autoOrderTimer: any = null
  restaurantCenter.on([RESTAURANT_EVENT.ORDER_WAITING_ACCEPTED, RESTAURANT_EVENT.ORDER_CART_DELETED], ({ order }) => {
    clearInterval(autoOrderTimer)
    const history = getHistoryNew()
    if (order?.status === 'NotAccepted' || order?.status === 'Pending') {
      autoOrderTimer = setInterval(() => {
        orderMobx.init(order.ordersId).then((res: any) => {
          // 定时任务已接单
          if (res.status !== 'NotAccepted') {
            // 需要判断当前购物车餐品已经在订单里面了，就清除购物车
            const isInOrder = some(cartMobx.viewCartItems, (item) => !!orderMobx.pkToViewDetail[item.pk])
            if (isInOrder) {
              cartMobx.clear()
            }
            // 'Success' | 'Pending' | 'NotAccepted' | 'Cancel' | 'Timeout' | 'Paying'
            // 终结状态需要
            if (['Success', 'Cancel', 'Timeout'].includes(res.status)) {
              clearInterval(autoOrderTimer)
              cartMobx.reset(1, 'pickup')
              history.replace(`result/${order.ordersId}`)
            }
          }
        })
      }, 10000)
    }
  })

  // for dev
  if (window.MX) {
    window.MX.debug = () => {
      modalLayer(DevelopModal, {}, 'developModal').catch(() => { })
    }
    window.MX._ = '使用MX.debug()开启配置弹窗'
  }
}
